import { Divider } from 'antd';
import React, { useEffect, useMemo, useState } from 'react'
import { useLoading } from '../../context/LoadingProvider/useLoading';

import { getPulltabDecksList } from '../../services/pulltabDecks';
import RawHtml, { iListGames, iLocation } from './RawHtml';
import SearchBar from './SearchBar';
import { sendSystemLog } from '../../context/AuthProvider/useAuth';

interface IDecks {
  migration_message?: string;
  error_migration?: boolean;
  location: iLocation
  listGames: iListGames[]
}

function index(props: { accessLevel: string }) {
  const loading = useLoading()

  const [decks, setDecks] = useState<IDecks>({
    migration_message: '',
    error_migration: false,
    location: {
      id: 0,
      name: "",
      closeAtBusinessDayEnd: false,
      closeAtMonthEnd: false,
      currentDate: "",
      status: ""
    },
    listGames: [
      {
        id: 0,
        title: "",
        image: "",
        gameAvailable: false,
        gameAvailableStart: "",
        gameAvailableEnd: "",
        listItemsGame: [{
          id: 0,
          wager: "",
          avaliable: false,
          autoCreate: false,
          autoClose: false,
          gameAutoClose: false,
          gameAutoCreate: false,
          form: "",
          tickets: 0,
          gameGroup: null,
          pivotForm: null,
          variant: "",
          serial: "",
          remaining: "",
          isClosing: false,
          gameAvailableStartSetting: false,
          gameAvailableStart: "",
          gameAvailableEndSetting: false,
          gameAvailableEnd: "",
          gameAvailable: false
        }]
      }
    ]
  })

  const [search, setSearch] = useState({
    text: '',
    params: {
      id: '',
      name: '',
      type: '',
    }
  });
  
  const log = {
    log_type: 'visited',
    log_object: 'decks'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])

  //useEffect(() => {
    //console.log("Decks:");
    //console.log(decks);
  //}, [decks])

  const getItems = async (type?: string, id?: string, payload?: any) => {
    loading.addLoading()
    const params = { [`${type || search.params.type}Id`]: id || search.params.id }
    const res = await getPulltabDecksList(params)
    setDecks(res)
    if(payload) {
      setSearch(payload)
    }
    const floatingButtonConfirm = document.getElementById('floating-button-confirm')
    if(floatingButtonConfirm) floatingButtonConfirm.style.display = 'none'
    const floatingButtonCancel = document.getElementById('floating-button-cancel')
    if(floatingButtonCancel) floatingButtonCancel.style.transform = 'translate(1000px, 0px)'
    loading.removeLoading()
  }

  return (
    <div className="pulltab-decks">
      <meta name="viewport" content="width=device-width, initial-scale=.75"/>
      <SearchBar getItems={getItems}/>
      {decks.error_migration && decks.migration_message && (
        <div className="pulltab-decks__title">
          {decks.migration_message}
        </div>
      )}
      {decks.location && <RawHtml location={decks.location} listGames={decks.listGames} onSave={getItems}/>}
    </div>
  )
}

export default index
